export default {
      id: "oc-res-resource-type-setting-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-resource-type-setting",
      toString: function () {
        return this.url;
      }
    }